import cn from 'classnames';
import type { ReactNode } from 'react';
import styles from './horizontal-overflow.module.css';

export type HorizontalOverflowProperties = {
  children: ReactNode;
  className?: string;
};

const HorizontalOverflow = ({ children, className }: HorizontalOverflowProperties) => (
  <div className={cn(styles['horizontal-overflow'], className)}>
    <div className={styles['horizontal-overflow__content']}>{children}</div>
  </div>
);

export default HorizontalOverflow;
